import "./styles.css";
const Home = () => {
  return (
    <div className="main container">
      <h1>
        Olá, eu sou o <br />
      </h1>
      <h2>Diego Vicente Pereira</h2> <p>FullStack Developer</p>
    </div>
  );
};

export default Home;
